import React from 'react';
import { MdOutlineInventory2 } from 'react-icons/md';
import { lazyPage } from '../lazyPage';

const CatalogPage = lazyPage(() => import(/* webpackChunkName: "m-commerce" */ './pages/CatalogPage'));

/**
 * Product Catalog feature manifest.
 *
 * Shares `featureName` with the Order Desk manifest on purpose: Catalog is part of
 * the same Commerce capability and is gated by the same permission for now. The
 * registry merges sidebar items across manifests that declare the same featureName,
 * so both links appear under one permission.
 */
const catalogManifest = {
    id: 'catalog',
    featureName: 'order_desk_mgmt',
    permission: 'view',
    routes: [{ path: '/catalog', element: <CatalogPage /> }],
    sidebarItems: [{ text: 'Product Catalog', icon: <MdOutlineInventory2 />, link: '/catalog' }],
};

export default catalogManifest;
